// import log from "loglevel";
import { GetterTree, Module } from "vuex";
import { ActionContext } from "vuex";
import { RootState } from "@/store";

type MyActionContext = ActionContext<commonState, RootState>;

export interface notificationData {
  label: string;
  style: string;
  linkLabel: string;
  link: string;
}

export interface commonState {
  notificationItem: notificationData;
}

export default {
  namespaced: true,
  state: {
    notificationItem: {
      label: "",
      style: "",
      linkLabel: "",
      link: "",
    },
  } as commonState,

  getters: {
    getNotificationItem: (state) => {
      return state.notificationItem;
    },
  } as GetterTree<commonState, RootState>,

  mutations: {
    setNotification(state: commonState, payload: notificationData): void {
      state.notificationItem = payload;
    },
    deleteNotification(state: commonState): void {
      state.notificationItem = {
        label: "",
        style: "",
        linkLabel: "",
        link: "",
      };
    },
  },
  actions: {
    createNotification(
      context: MyActionContext,
      params: notificationData
    ): void {
      context.commit("setNotification", params);
      // setTimeout(() => {
      //   context.commit("deleteNotification");
      // }, 5000);
    },
    createErrorNotification(
      context: MyActionContext,
      params: notificationData
    ): void {
      context.commit("setNotification", params);
    },
    afterRedirectNotification(
      context: MyActionContext,
      params: notificationData
    ): void {
      sessionStorage.setItem("label", params.label);
      sessionStorage.setItem("style", params.style);
    },
  },
} as Module<commonState, RootState>;
